<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <v-layout align-center justify-center column>
          Social sign-in is no longer supported. Please use your email and password to log in.
        </v-layout>       
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'SocialSignIn',

  props: {
    heading: {
      type: String,
      required: true
    }
  },

  data () {
    
    return {
      facebookSignInURL: `https://${process.env.VUE_APP_AWS_COGNITO_AUTH_SERVER}/oauth2/authorize?response_type=code&client_id=${process.env.VUE_APP_AWS_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_AWS_COGNITO_AUTH_REDIRECT_URI}&identity_provider=Facebook`,
      twitterSignInURL: null,
      googleSignInURL: `https://${process.env.VUE_APP_AWS_COGNITO_AUTH_SERVER}/oauth2/authorize?response_type=code&client_id=${process.env.VUE_APP_AWS_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_AWS_COGNITO_AUTH_REDIRECT_URI}&identity_provider=Google`,
      appleSignInURL: `https://${process.env.VUE_APP_AWS_COGNITO_AUTH_SERVER}/oauth2/authorize?response_type=code&client_id=${process.env.VUE_APP_AWS_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_AWS_COGNITO_AUTH_REDIRECT_URI}&identity_provider=SignInWithApple&scope=aws.cognito.signin.user.admin email openid profile`,
      showAppleSignIn: true
    }
  },
  mounted () {
    if(window.location.href.includes("showAppleSignIn=true")){
      this.showAppleSignIn = true
    }
  },
  methods: {
    authenticate (provider) {
      this.$auth.authenticate(provider).then(function () {
        // Execute application logic after successful social authentication
        console.log('SOCIAL AUTH')
      })
    }
  }
}
</script>

<style scoped>
</style>